import { AddCircle } from "@mui/icons-material";
import { visio } from "assets/images/illustrations";
import Button from "components/atoms/Button/Button";
import Modal from "components/atoms/Modal/Modal";
import useModal from "components/atoms/Modal/useModal";
import fr from "locales/fr";
import { FormattedMessage } from "react-intl";
import CreateVideoCall from "./CreateVideoCall/CreateVideoCall";
import VideoCallsList from "./VideoCallsList/VideoCallsList";
import useVideoCalls from "./useVideoCalls";
import { useSelectedLinkContext } from "contexts";
import { VideoCallParticipant } from "./CreateVideoCall/useVideoCallParticipants";
import { Bounce, toast } from "react-toastify";
import Toast from "components/atoms/Toast/Toast";


const VideoCallsHome = (): JSX.Element => {
  const { 
    isModalOpened: isVideoCallCreationModalOpened,
    openModal: openVideoCallCreationModal,
    closeModal: closeVideoCallCreationModal 
  } = useModal(false);
  const selectedLinkContext = useSelectedLinkContext();

  const { data: videoCalls, refetch: refetchVideoCalls, createVideoCall } = useVideoCalls();

  const sendInvites = (participants: VideoCallParticipant[]): void => {
    closeVideoCallCreationModal();
    createVideoCall(participants.map(participant => participant.email))
    .then(() => {
      void refetchVideoCalls();
      toast.info(
        <Toast 
          body={<FormattedMessage id="videoCall.home.videoCallList.createdToast.body" />} 
          title={<FormattedMessage id="videoCall.home.videoCallList.createdToast.title" />} 
        />, 
        {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          transition: Bounce,
          theme: 'colored',
      });
    }).catch(() => {
      void refetchVideoCalls();
    });
  };

  return  <div className='flex flex-col items-center gap-y-4w w-full'>
            <h1 className='text-header3'><FormattedMessage id="videoCall.home.title" /></h1>

            <img className="size-[178px]" alt="visio illustration" src={visio}></img>

            <p className='text-subtitle1 text-center' style={{whiteSpace: 'pre-line'}}>
              <FormattedMessage id="videoCall.home.explainations" values={
                { tabletOwner: `${selectedLinkContext.selectedLink.mainUser.firstName} ${selectedLinkContext.selectedLink.mainUser.lastName}` }
              } />
            </p>

            <Button onClick={openVideoCallCreationModal}>
              <span className='flex justify-center items-center gap-1w'><AddCircle />Créer un salon vidéo</span>
            </Button>

            <section id="videoCallsList" className="flex flex-col items-center gap-y-2w mx-auto">
              <h2 className='text-header5'>
                <FormattedMessage id='videoCall.home.videoCallList.title'></FormattedMessage>
              </h2>
              <VideoCallsList videoCalls={videoCalls} />
            </section>
            {isVideoCallCreationModalOpened && 
              <Modal title={fr.messages['videoCall.create.title']} onClose={closeVideoCallCreationModal}>
                <CreateVideoCall onInvitesSent={sendInvites} />
              </Modal>
            }
          </div>;
};

export default VideoCallsHome;